import React, { useState } from "react";
import "./App.css";
import CurrentDate from "./CurrentDate";
import axios from "axios";
import Temprature from "./Temprature";
import Weatherforcast from "./Weatherforcast";
export default function GetData(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);
  function handleResponse(response) {
    console.log(response);
    setWeatherData({
      ready: true,
      coordinates: response.data.coord,
      temperature: Math.round(response.data.main.temp),
      humidity: response.data.main.humidity,
      date: new Date(response.data.dt * 1000),
      description: response.data.weather[0].description,
      imgurl: `https://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`,
      wind: response.data.wind.speed,
      city: response.data.name,
    });
    // console.log(weatherData.icon);
  }

  function search() {
    const apiKey = "5f472b7acba333cd8a035ea85a0d4d4c";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  function getInputValue(event) {
    let cityName = event.target.value;
    let captilizedCityName =
      cityName.charAt(0).toUpperCase() + cityName.slice(1).toLowerCase();
    setCity(captilizedCityName);
  }

  function handlesubmit(event) {
    event.preventDefault();
    search();
  }
  if (weatherData.ready) {
    return (
      <div>
        <div className="input-search">
          <form id="get-cityname" onSubmit={handlesubmit}>
            <input
              type="search"
              className="EnterCity-input"
              placeholder="Enter a city"
              id="get-cityname-input"
              onChange={getInputValue}
            />
            <input type="submit" className="Search-input" value="Search" />
          </form>
        </div>
        <div className="place-temper">
          <h3 className="city-name">
            <strong>{weatherData.city}</strong>
          </h3>
          <CurrentDate />

          <p className="city-temper">
            <br />
          </p>
          <p id="condition">{weatherData.description}</p>
        </div>
        <div className="description">
          <Temprature
            temprature={weatherData.temperature}
            url={weatherData.imgurl}
          />

          <div className="right-part">
            <p>
              Humidity : <span id="humidityId"> {weatherData.humidity}</span>%
            </p>
            <p>
              Wind : <span id="windId"> {weatherData.wind}</span> m/h
            </p>
          </div>
        </div>

        <Weatherforcast
          coordinate={weatherData.coordinates}
          imgurl={weatherData.imgurl}
        />
      </div>
    );
  } else {
    search();
    return <p>loading...</p>;
  }
}
